import axios, { AxiosRequestConfig } from "axios";
import { Empresa, UpdateEmpresa } from "../types/empresas";

export const getEmpresas = async (token: string): Promise<Empresa[]> => {
  try {
    const config: AxiosRequestConfig = {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
        "ngrok-skip-browser-warning": "true",
      },
    };

    const url = `${process.env.REACT_APP_API_DOMAIN}/manager/empresa`;
    const response = await axios.get(url, config);
    return response.data;
  } catch (error) {
    console.error("Erro ao buscar empresas:", error);
    throw error;
  }
};

export const getEmpresaById = async (
  token: string,
  id: string
): Promise<Empresa> => {
  try {
    const config: AxiosRequestConfig = {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
        "ngrok-skip-browser-warning": "true",
      },
    };

    const url = `${process.env.REACT_APP_API_DOMAIN}/manager/empresa/${id}`;
    const response = await axios.get(url, config);
    return response.data;
  } catch (error) {
    console.error("Erro ao buscar empresa:", error);
    throw error;
  }
};

export const createEmpresa = async (token: string, empresaData: FormData) => {
  try {
    const config: AxiosRequestConfig = {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "multipart/form-data",
        "ngrok-skip-browser-warning": "true",
      },
    };

    const url = `${process.env.REACT_APP_API_DOMAIN}/manager/empresa`;
    const response = await axios.post(url, empresaData, config);
    return response.data;
  } catch (error) {
    console.error("Erro ao adicionar empresa:", error);
    throw error;
  }
};

export const updateEmpresa = async (
  token: string,
  id: string,
  empresaData: UpdateEmpresa
) => {
  try {
    const config: AxiosRequestConfig = {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
        "ngrok-skip-browser-warning": "true",
      },
    };

    const url = `${process.env.REACT_APP_API_DOMAIN}/manager/empresa/${id}`;
    const response = await axios.put(url, empresaData, config);
    return response.data;
  } catch (error) {
    console.error("Erro ao atualizar empresa:", error);
    throw error;
  }
};

export const deleteEmpresa = async (token: string, id: string) => {
  try {
    const config: AxiosRequestConfig = {
      headers: {
        Authorization: `Bearer ${token}`,
        "ngrok-skip-browser-warning": "true",
      },
    };

    const url = `${process.env.REACT_APP_API_DOMAIN}/manager/empresa/${id}`;
    const response = await axios.delete(url, config);
    return response.data;
  } catch (error) {
    console.error("Erro ao excluir empresa:", error);
    throw error;
  }
};
